import { message as antMessage } from '@grininc/grin-ui';
import _ from 'lodash';
import { requestErrors } from '../helpers';

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please contact support if this problem persists.';

const message = _.assign(antMessage, {
    /**
     * Show a default error message
     */
    defaultError(content = DEFAULT_ERROR_MESSAGE, duration = 5) {
        antMessage.error(content, duration);
    },

    /**
     * @param {Object} res
     */
    responseError(res) {
        message.error(requestErrors(res));
    }
});

message.config({ action: true });

const useMessage = () => {
    return {
        message
    };
};

export default useMessage;
